// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vTitle[data-v-8d16d25c] {\n  background-image: -webkit-linear-gradient(top, #fff, #a1c7e8, #7bbef6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: 0.09rem;\n  line-height: 0.15rem;\n  font-weight: 600;\n}\n.titleIs[data-v-8d16d25c] {\n  width: 1.1rem;\n}\n@media (max-width: 1280px) {\n.titleIs[data-v-8d16d25c] {\n    width: 0.9rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
